export default {
  namespaced: true,
  state: {
    routerPath: '' // 当前路由路径

  },
  mutations: {
    SET_ROUTER_PATH: function SET_ROUTER_PATH(state, value) {
      state.routerPath = value;
    }
  }
};